<template>
  <div class="pictures-page">
    <el-row :gutter="20">
      <el-col :span="4" :offset="0" v-for="(folder,index) in folders" :key="index">
        <div class="folder" @click="activeIndex = index">
          <el-image class="folder-image"
            src="/images/tpcx/folder.svg"
            :preview-src-list="srcList">
          </el-image>
          <div>{{folder.name}}</div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeIndex: 0,
      folders: [
        { name: '果酸仙女棒详情页-V1', path: 'V1', num: 8 },
        { name: '果酸仙女棒详情页-V2', path: 'V2', num: 9 }
      ]
    }
  },
  computed: {
    srcList () {
      const list = []
      if (this.activeIndex !== undefined) {
        const path = this.folders[this.activeIndex].path
        const num = this.folders[this.activeIndex].num
        for (let i = 0; i < num; i++) {
          const url = '/images/tpcx/' + path + '/' + path + '_' + (i * 1 + 1) + '.jpg'
          list.push(url)
        }
      }
      return list
    }
  }
}
</script>

<style scoped>
.pictures-page{
  max-width: 1200px;
  margin: 0 auto;
  padding: 100px 5px;
  box-sizing: border-box;
  display: flex;
}
.folder-image{
  width: 80%;
}
.folder{
  font-size: 12px;
  cursor: pointer;
}
</style>
